// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1sWly","col":"styles_col__19n9r"};